import { AppContextType } from './../context/AppContext';

/**
 * Returns the Prismic UID for the english version of the page.
 * Falls back on the current page's uid (if present)
 * or the Prismic document type (e.g. 404_page)
 * @param context The context's full data
 *
 */
export const getEnglishUIDFromContext = (context: AppContextType): any => {
    const en = 'en-us';

    if (context.pageContext.lang === en) {
        return context.pageContext.uid;
    }

    const enPage = context.alternateLanguages.find((p: any) => p.lang === en);
    if (enPage && enPage.uid) {
        return enPage.uid;
    }
};
